import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2.5 20A2.5 2.5 0 0 1 0 17.5V15a2.5 2.5 0 0 1 .733-1.768l12.5-12.5a2.5 2.5 0 0 1 3.534 0l2.5 2.5a2.5 2.5 0 0 1 0 3.536l-12.5 12.5A2.5 2.5 0 0 1 5 20.001zm0-5v2.5H5l9.741-9.743-2.5-2.5zm14.009-9.01L17.5 5 15 2.5l-.991.99z" }));
const ForwardRef = forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
